<template>
    <div>
        <div class="printable">
            <b-row>
                <b-col cols="12" xl="4" class="my-1">
                    <b-form inline> 
                        <b-button @click="goTo('index')" variant="transparent" size="sm" class="pull-left">
                            <font-awesome-icon icon="angle-left" size="2x" />
                        </b-button>
                        &nbsp;
                        <h3 class="text-themecolor my-1">Order {{workOrder ? ((workOrder.createdAt || '').substr(0,4) + '-' +  (workOrder.number ? workOrder.number : '')) : ''}}</h3>
                    </b-form>
                </b-col>
                <b-col cols="12" xl="8" class="my-1 no-printable" v-if="workOrder">
                    <div class="pull-right">
                        <b-button size="sm" v-b-modal.modalSendOffer variant="themecolor" class="mr-1">
                            <i class="fa fa-paper-plane" aria-hidden="true"></i> {{$t('buttons.offerteversturen')}}
                        </b-button>
                        <b-button size="sm" @click.stop="goTo('copy')" variant="themecolor" class="mr-1">
                            <i class="fa fa-copy" aria-hidden="true"></i> {{$t('buttons.kopieren')}}
                        </b-button>
                        <b-button size="sm" @click="printPage()" variant="themecolor" class="mr-1">
                            <i class="fa fa-print" aria-hidden="true"></i> {{$t('buttons.printen')}}
                        </b-button>
                        <b-button size="sm" @click.stop="goTo('update')" variant="themecolor" class="mr-1">
                            <i class="fa fa-edit" aria-hidden="true"></i> {{$t('buttons.bewerken')}}
                        </b-button>
                        <delete title="Order" :id="workOrder.id" namespace="comceptum" resource="workorders" />
                    </div>
                </b-col>
            </b-row>
            <div class="container-fluid">
                <b-row>
                    <b-col md="12" lg="4">
                        <div class="card h-100">
                            <div class="card-body">
                                <h4 class="card-title">{{$t('order.factuurgegevens')}}</h4>

                                <div v-if="workOrder">
                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.relatienaam')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.contactPersons.length> 0">{{workOrder.contactPersons[0].customerRelation.name}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>
                                    
                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.contactpersonen')}}</small></b-col>
                                        <b-col cols="12" xl="6"><h6 class="font-weight-bold">{{ formatToInlineText(workOrder.contactPersons) }}</h6></b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.relatienummer')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.contactPersons.length> 0">{{workOrder.contactPersons[0].customerRelation.tag}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.administratie')}}</small></b-col>
                                        <b-col cols="12" xl="6"><h6 class="font-weight-bold" v-if="workOrder.administration">{{workOrder.administration.name}}</h6></b-col>
                                    </b-row>
                                    

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.factuurnummer')}}</small></b-col>
                                        <b-col cols="12" xl="6" @dblclick="editingFactuurNummer = true" id="factuurEdit" :title="$t('hoverpopup.dubbelklikomaantepassen')" class="clickable">
                                            <h6 class="font-weight-bold" v-show="!editingFactuurNummer" v-if="workOrder.invoiceNumber">{{workOrder.invoiceNumber}}</h6>
                                            <h6 class="font-weight-bold" v-show="!editingFactuurNummer" v-else>{{$t('error.onbekend')}}</h6>

                                            <input id="factuurNummer" v-model="workOrder.invoiceNumber" v-show="editingFactuurNummer"
                                                @keyup.enter="updateInvoiceNumber($event)" v-on:blur="updateInvoiceNumber($event)" type='text' class="w-100">
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.referentie')}}</small></b-col>
                                        <b-col cols="12" xl="6" @dblclick="editingReference = true" id="referenceEdit" :title="$t('hoverpopup.dubbelklikomaantepassen')" class="clickable">
                                            <h6 class="font-weight-bold" v-show="!editingReference" v-if="workOrder.reference">{{workOrder.reference}}</h6>
                                            <h6 class="font-weight-bold" v-show="!editingReference" v-else>{{$t('error.onbekend')}}</h6>

                                            <input id="factuurNummer" v-model="workOrder.reference" v-show="editingReference"
                                                @keyup.enter="updateReference($event)" v-on:blur="updateReference($event)" type='text' class="w-100">
                                        </b-col>
                                    </b-row>        
                                </div>
                                <div v-else>
                                    <content-placeholders>
                                        <content-placeholders-heading />
                                        <content-placeholders-text :lines="8" />
                                    </content-placeholders>
                                </div>
                            </div>

                        </div>
                    </b-col>
                    <b-col md="12" lg="4">
                        <div class="card h-100">
                            <div class="card-body">
                                <h4 class="card-title">{{$t('order.opleveringsinformatie')}}</h4>

                                <div v-if="workOrder">
                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.verantwoordelijken')}}</small></b-col>
                                        <b-col cols="12" xl="6"><h6 class="font-weight-bold" >{{ formatToInlineText(workOrder.assignedUsers) }}</h6></b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.drukkerij')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.printingCompany">{{workOrder.printingCompany}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.verspreider')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.diffuser">{{workOrder.diffuser}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.uitgeverij')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.publisher">{{workOrder.publisher}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.status')}}</small></b-col>
                                        <b-col col md="12" lg="6" @dblclick="editingStatus = true" :title="$t('hoverpopup.dubbelklikomaantepassen')" class="clickable">
                                            <h6 class="font-weight-bold" v-show="!editingStatus">{{workOrderStatusses.filter(({key}) => key === workOrder.status)[0].value}}</h6>
                                            <select v-show="editingStatus" v-model="workOrder.status" @change="updateStatus($event)" :disabled="savingStatus">
                                                <option v-for="item in workOrderStatusses" v-bind:key="item.id" :value="item.key">
                                                    {{ item.value }}
                                                </option>
                                            </select>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div v-else>
                                    <content-placeholders>
                                        <content-placeholders-heading />
                                        <content-placeholders-text :lines="10" />
                                    </content-placeholders>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="12" lg="4">
                        <div class="card h-100">
                            <div class="card-body">
                                <h4 class="card-title">{{$t('order.datums')}}</h4>

                                <div v-if="workOrder">
                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.aangemaaktop')}}</small></b-col>
                                        <b-col cols="12" xl="6"><h6 class="font-weight-bold">{{workOrder.createdAt | datetime}}</h6></b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.gewijzigdop')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.lastAudit">{{workOrder.lastAudit.createdAt | datetime}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.datum1eproef')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.firstTestDate">{{workOrder.firstTestDate | date}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.datumdrukker')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.printingCompanyDate">{{workOrder.printingCompanyDate | date}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.datumverspreider')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.diffuserDate">{{workOrder.diffuserDate | date}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" xl="6"><small class="text-muted">{{$t('order.datumlevering')}}</small></b-col>
                                        <b-col cols="12" xl="6">
                                            <h6 class="font-weight-bold" v-if="workOrder.deliveryDate">{{workOrder.deliveryDate | date}}</h6>
                                            <h6 class="font-weight-bold" v-else>{{$t('error.onbekend')}}</h6>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div v-else>
                                    <content-placeholders>
                                        <content-placeholders-heading />
                                        <content-placeholders-text :lines="12" />
                                    </content-placeholders>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="container-fluid">
                <b-row>
                    <b-col cols="12" xl="6">
                        <div v-if="workOrder">
                            <OrderLines :orderLines="orderLines" :invokeApi="true" v-on:updateReference="updateReference" />
                        </div>
                        <div v-else>
                            <content-placeholders>
                                <content-placeholders-heading/>
                                <content-placeholders-text :lines="2"/>
                            </content-placeholders>
                        </div>                    
                    </b-col>
                    <b-col cols="12" xl="6">
                        <div v-if="workOrder">
                            <OrderTimes />
                        </div>
                        <div v-else>
                            <content-placeholders>
                                <content-placeholders-heading/>
                                <content-placeholders-text :lines="2"/>
                            </content-placeholders>
                        </div>    
                    </b-col>
                </b-row>
            </div>
            <div class="container-fluid">
                <b-row>
                    <b-col md="12" lg="6" class="printable-w100">
                        <div v-if="workOrder">
                            <Notes :entityId="workOrder.id" />
                        </div>
                        <div v-else>
                            <content-placeholders>
                                <content-placeholders-heading/>
                                <content-placeholders-text :lines="2"/>
                            </content-placeholders>
                        </div>
                    </b-col>
                    <b-col md="12" lg="6" class="no-printable">
                        <div v-if="workOrder">
                            <Attachments :entityId="workOrder.id" /> 
                        </div>
                        <div v-else>
                            <content-placeholders>
                                <content-placeholders-heading/>
                                <content-placeholders-text :lines="2"/>
                            </content-placeholders>
                        </div>                    
                    </b-col>
                </b-row>
            </div>
            <b-row class="no-printable">
                <b-col md="12" class="my-3">
                    <b-button-group class="mx-1">
                        <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.terugnaaroverzicht')}}</b-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </div>
        <!-- Modal Component -->
        <b-modal id="modalSendOffer" ref="sendOffer" :title="$t('order.verstuurofferte')"
        centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.versturen')" @ok="sendOffer">
            <b-form autocomplete="off">
                <!-- Form content -->
                <b-table show-empty stacked="md" class="table-hover lines-table" :items="orderLines" :fields="orderLineFields">
                    <template v-slot:cell(check)="data">
                        <!-- We use click.native.stop here to prevent 'sort-changed' or 'head-clicked' events -->
                        <b-form-checkbox @click.native.stop :value="data.item.id" v-model="sendOfferCommand.orderLineIds" />
                    </template>
                    <template v-slot:cell(lineNumber)="row">{{row.index + 1}}</template>
                    <template v-slot:cell(salesAmount)="data">{{data.item.salesAmount | currency}}</template> 
                </b-table>
                <!-- Form content -->
            </b-form>
        </b-modal>
        <!-- Modal Component -->
    </div>
</template>
<script>
//Import components
import OrderLines from "./orderlines/OrderLines";
import OrderTimes from "./ordertimes/OrderTimes";
import Notes from "@/components/notes/Notes";
import Attachments from "@/components/attachments/Attachments";

import Command from "./command";
import AttachmentCommand from "@/components/attachments/command";
import SendOfferCommand from "./sendOfferCommand";

//Import store
import { mapActions, mapGetters } from "vuex";


export default {
  name: "workorder-detail",
  data() {
    return {
      workOrder: null,
      sendOfferCommand: new SendOfferCommand(),
      orderLines: [],
      orderTimes: [],
      editingFactuurNummer: false,
      editingReference: false,
      editingStatus: false,
      savingStatus: false,
    };
  },
  components: {
    OrderLines,
    OrderTimes,
    Notes,
    Attachments
  },
  computed: {
      orderLineFields() {
        return [
            { key: 'check', label: '', tdClass: 'small-checkbox' },
            { key: 'lineNumber', label: this.$i18n.t('datatables.nr') },
            { key: 'description', label: this.$i18n.t('datatables.omschrijving') },
            { key: 'salesAmount', label: this.$i18n.t('datatables.prijsverkoop') }
        ]
      },
    ...mapGetters("comceptum", ["workOrderStatusses"])
  },
  methods: {
    ...mapActions("comceptum", ["find", "delete", "update", "execute"]),
    ...mapActions("shared", ["create"]),
    formatToInlineText(items) {
      if(items.length == 0) return '';

      var inlineText = "";
      for (var i = 0; i < items.length; i++) {
        inlineText += items[i].fullName + ", ";
      }

      inlineText = inlineText.slice(0, -2);

      return inlineText;
    },
    goTo(name) {
      this.$router.push({ name: `workorders:${name}` });
    },
    printPage() {
        window.print();
	},
    updateOrder(workOrderPatch, onSuccess) {
        let vm = this;
        vm.update({
            resource: "workorders",
            params: new Command({...vm.workOrder, ...workOrderPatch})
        }).then(() => {
            onSuccess();
        });
    },
    updateInvoiceNumber(event) {
        let vm = this;
        if (!vm.editingFactuurNummer) return;

        vm.updateOrder({invoiceNumber: event.target.value}, () => {
            vm.editingFactuurNummer = false;
        });
    },
    updateReference(event) {
      let vm = this;
      if(!vm.editingReference) return;

      vm.updateOrder({reference: event.target.value}, () => {
          vm.editingReference = false;
      });
    },
    updateStatus() {
        let vm = this;
        if(!vm.editingStatus) return;

        vm.savingStatus = true;

        vm.updateOrder({status: event.target.value}, () => {
            vm.editingStatus = false;
            vm.savingStatus = false;
        });
    },
    sendOffer() {
      const vm = this;

      const payload = {
        resource: "workorders",
        id: vm.workOrder.id,
        action: "send-offer",
        params: vm.sendOfferCommand
      };

      vm.execute(payload).then(base64 => {
        var workOrderPatch = {
            numberOfOffersSent: vm.workOrder.numberOfOffersSent + 1
        }

        var attachmentCommand = new AttachmentCommand();
        attachmentCommand.entityId = vm.workOrder.id;
        attachmentCommand.name = "offerte " + vm.workOrder.createdAt.substr(0,4) + '-' +  vm.workOrder.number + "-" + workOrderPatch.numberOfOffersSent + ".pdf";
        attachmentCommand.content = base64;

        const payload = {
          resource: "attachments",
          entityId: vm.workOrder.id,
          params: attachmentCommand
        };

        vm
          .create(payload)
          .then(() => {
            vm.$swal(
              this.$i18n.t('succes.succes'),
              `${this.$i18n.t('succes.deofferteisklaargezetindeconceptenmap')}`,
              this.$i18n.t('succes.success')
            );

            this.$store.commit('comceptum/update', {
                resource: "workorders",
                result: { ...vm.workOrder, ...workOrderPatch }
            })

            vm.sendOfferCommand = new SendOfferCommand();
          })
          .catch(() => {
            vm.$swal(
              this.$i18n.t('delete.mislukt'),
              `${this.$i18n.t('error.debijlagekonnietwordenaangemaakt')}`,
              this.$i18n.t('delete.error')
            );
          });
      });
    }
  },
  created() {
        var vm = this;
        vm.find({
            resource: "workorders",
            id: vm.$route.params.workOrderId,
            cacheResult: false
        }).then((data) =>{
            vm.workOrder = data;
        });

        //Get orderlines
        vm.$store.dispatch('comceptum/search',`workorders/${vm.$route.params.workOrderId}/lines`)
        .then((data) => {
            data.forEach(function(element) { element._showDetails = false; });
            vm.orderLines = data;
        });     
  }
};
</script>
<style>
.clickable {
  cursor: pointer;
  text-decoration: underline;
}
</style>
